{
  "font-family": {
    "font-family-sans": "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
    "font-family-display": "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
    "font-family-system": "'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
    "font-family-mono": "'JetBrains Mono', ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, 'Liberation Mono', monospace"
  },
  "font-size": {
    "font-size-12": "0.75rem",
    "font-size-14": "0.875rem",
    "font-size-16": "1rem",
    "font-size-18": "1.125rem",
    "font-size-20": "1.25rem",
    "font-size-22": "1.375rem",
    "font-size-24": "1.5rem",
    "font-size-30": "1.875rem",
    "font-size-36": "2.25rem",
    "font-size-48": "3rem",
    "font-size-56": "3.5rem",
    "font-size-64": "4rem"
  },
  "font-weight": {
    "font-weight-light": 300,
    "font-weight-regular": 400,
    "font-weight-medium": 500,
    "font-weight-semibold": 600,
    "font-weight-bold": 700,
    "font-weight-extrabold": 800
  },
  "line-height": {
    "line-height-none": 1,
    "line-height-tight": 1.2,
    "line-height-snug": 1.3333333,
    "line-height-base": 1.5,
    "line-height-relaxed": 1.6,
    "line-height-loose": 1.75
  },
  "letter-spacing": {
    "letter-spacing-tight": "-0.0125em",
    "letter-spacing-normal": "0em",
    "letter-spacing-wide": "0.025em"
  }
}
